import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCartFillH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.302 14.652a1.769 1.769 0 1 1-3.538 0 1.769 1.769 0 0 1 3.538 0M14.267 14.652a1.769 1.769 0 1 1-3.538 0 1.769 1.769 0 0 1 3.538 0M14.399 3.95c.892 0 1.554.827 1.36 1.699l-1.157 5.212a1.395 1.395 0 0 1-1.363 1.091H5.86a1.396 1.396 0 0 1-1.359-1.077L3.067 4.75A.65.65 0 0 1 3.7 3.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.578 1.709a1.395 1.395 0 0 1 1.366 1.078l1.173 5.017A.65.65 0 0 1 3.85 8.1L2.678 3.082a.096.096 0 0 0-.094-.073l-1.41.008a.65.65 0 0 1-.007-1.3z"
  }));
}
var IcCartFillH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCartFillH18));

export { IcCartFillH18 as I };
